export const toLowerCase = (str: string) => str.toLocaleLowerCase();
